/**
 * Public Layout Component
 *
 * Shared layout for all public/unauthenticated pages with consistent
 * header navigation and footer.
 */

import { PublicNav } from './PublicNav';
import { PublicFooter } from './PublicFooter';

interface PublicLayoutProps {
  children: React.ReactNode;
  /** Background class for the main content area */
  bgClass?: string;
  /** Whether to show the full navigation or a simplified one */
  minimal?: boolean;
}

export default function PublicLayout({ children, bgClass = 'bg-white' }: PublicLayoutProps) {
  return (
    <div className={`min-h-screen flex flex-col ${bgClass}`}>
      {/* Navigation */}
      <PublicNav />

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
}
